<!--
This component generates the invites list group for the specified {{status}.
Receiver must pass an array to {inviteData} to let the component generate the proper ui.
-->
<template>
  <section class="invite-section">
    <div class="list-group-container">
      <div class="d-flex flex-row list-row-header">
        <div class="p-2 w-50">Email</div>
        <div class="p-2 w-25">Individual Name</div>
        <div class="p-2 w-25">Invite Status</div>
        <div class="p-2 w-25" v-if="passStatus !== 'Inactive'">
          Action
        </div>
      </div>

      <!--Appears if there's no invite-->
      <div class="d-flex flex-row list-row-empty" v-if="!hasInvites">
        <div class="flex-fill">No invites sent yet.</div>
      </div>
      <!--end no invite-->
      <!-- appears if with invite/s -->
      <div class="list-rows" v-else>
        <div v-for="(data, index) in invites" :key="index" class="d-flex flex-row list-row">
          <div class="px-2 w-50 list-column-item"> {{ data.email }}</div>
          <div class="px-2 w-25 list-column-item" v-if="data.status === 'Accepted'">
            {{ data.individual_details.full_name }}
          </div>
          <div class="px-2 w-25 list-column-item" v-else>-</div>
          <div v-if="data.status === 'Pending' && passStatus !== 'Expired' && passStatus !== 'Deactivated'"
            class="px-2 w-25 list-column-item"
            @click="resendInvite(data.email, $event)">
            {{ data.status }} - Resend Invitation
          </div>
          <div class="px-2 w-25 list-column-item" v-else>{{ data.status }}</div>
          <div class="px-2 w-25 list-column-action" v-if="passStatus !== 'Inactive' && passStatus !== 'Deactivated'">
            <button class="simple-link" @click="deleteInvite(data, $event)">
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </div>
      </div>
      <!-- end with invites -->
    </div>
    <!--end list group-->
  </section>
</template>

<script>
import '@/assets/styles/list-style.css'

export default {
  name: 'invite-list-view',
  data() {
    return {
      isToDelete: this.accountType === 'business'
    }
  },
  props: {
    passStatus: String,
    accountType: String,
    invites: Array,
    hasInvites: Boolean,
    deleteInvite: Function,
    resendInvite: Function
  },
  computed: {
    statusObject: function () {
      return {
        'status-active': this.status === "Active",
        'status-inactive': this.status === "Inactive",
        'status-pending': this.status === "Pending"
      }
    }
  }
}
</script>

<style scoped>
.invite-section {

}
.invite-status-header {
  display:flex;
  align-items: center;
}
.invite-status-title {
  font-family: "HKGrotesk-Bold", Helvetica, sans-serif;
  color: #00386A;
  font-size: 20px;
}
.invite-status-indicator {
  width: 12px;
  height: 12px;

  border-radius: 100%;
  margin-right: 12px;
}

/* Status indicator color styles */
.status-active {
  background-color: #42BB79;
}
.status-inactive {
  background-color: #547181;
}
.status-pending {
  background-color: #EDC834;
}
</style>



// WEBPACK FOOTER //
// src/components/listview/InvitesListView.vue